document.addEventListener("DOMContentLoaded", function() {
    const images = document.querySelectorAll(".animate-me");
    setInterval(function () {
        let found_it = false;
        let done = false;
        images.forEach((image, index) => {
            if(!done){
                if (image.classList.contains("active")) {
                    image.classList.remove("active");
                    if(index < images.length - 1){
                        images[index + 1].classList.add("active");
                    } else if(index == images.length - 1){
                        images[0].classList.add("active");
                    }
                    done = true;
                }
            }
        });
    }, 1000);
});